export const Z_INDEX = {
  // Base layer
  BASE: 1,

  // Navigation and UI elements
  HEADER: 100,
  SIDEBAR: 200,

  // Overlay components (in order of precedence)
  MODAL_BACKDROP: 1000,
  MODAL_CONTENT: 1001,
  SLIDE_OVER_BACKDROP: 1100,
  SLIDE_OVER_CONTENT: 1101,

  // Secondary slide over (for nested modals like subtask on top of task)
  SLIDE_OVER_SECONDARY_BACKDROP: 1150,
  SLIDE_OVER_SECONDARY_CONTENT: 1151,

  // High priority overlays
  TOOLTIP: 1200,
  DROPDOWN: 1300,

  // Critical overlays (should always be on top)
  LOADING_OVERLAY: 9000,
  EMERGENCY_MODAL: 9999,

  // Above every overlay on purpose: a toast usually explains why the action behind the
  // modal failed, and a failed action leaves its modal open. Ranked below EMERGENCY_MODAL
  // it renders behind that modal and the explanation is unreadable.
  TOAST: 10000,
} as const;

export type ZIndexKey = keyof typeof Z_INDEX;